export default __webpack_public_path__ + "static/media/light_mode_landing.ebcd6d35.svg";